<template>
  <div class="card maturityR">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
          <div class="col blue">
            <h3><i class="fas fa-hourglass-half"></i>Intra Day Trades</h3>
          </div>
          <div class="text-right">
            <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> More Info</a>
          </div>
      </div>
    </div>
    <div class="card-body bid-detail">
      <div class="intra">
           {{count ? count : 0}} <small> Trades</small>
          <!-- <small class="print">
            <a href=""><i class="fas fa-print"> </i>Print All</a>
          </small> -->
      </div>
        
    </div>
  </div> 
</template>
<script>
 import config from "@/config";
 import authService from "@/authService";
export default {
  name: "intradayWidget",
  props :["offerStatus"],

  data() {
    return {
      count : 0,
      isAdmin: false,
      isTrader : false,
      isEditor : false,
    };
  },
  methods: {
    navigateListPage(){
      window.location.href = "/ims/ims-trades";
    },
    getIntraDayCount(){
      this.loading = true;
      let url = "/offer/intradayTradeCount";
      if((!this.isAdmin || !this.isEditor) && this.isTrader){
        url = "/offer/intradayTradeCount?cognitoSub="+authService.getUser().cognitoSub
      }
      const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
      .get(
        config.baseUrlBidSide +
          url,
          auth
      )
      .then(result => {
        this.count = result.data;
        this.loading = false;
      })

    },
  },
  mounted() {
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          //console.log(role)
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          this.getIntraDayCount();

        }
        //console.log("isa",this.isAdmin);
      });
  }
};
</script>